import './Card.scss';

import React from 'react';
import classNames from 'classnames';
import moment from 'moment';

import ActionMenu from 'components/ActionMenu';
import ActionMenuButton from 'components/ActionMenuButton';
import H4 from 'components/H4';
import Icon from 'components/Icon';
import Thumbnail from 'components/Thumbnail';

import { ASSIGNMENT_STATES, ASSIGNMENT_STATES_LOOKUP, ASSIGNMENT_STATUSES } from 'containers/AssignmentsPage/constants';
import { displayAssignmentStatus, stopAssignmentOrRemoveAssignment } from 'containers/AssignmentsPage/utils';
import { generateContentTypeLabel } from 'containers/ContentPage/utils';

export default class Card extends React.Component {
    static propTypes = {
        className: React.PropTypes.string,
        createAssignment: React.PropTypes.func,
        handleDelete: React.PropTypes.func,
        item: React.PropTypes.object.isRequired,
        onClick: React.PropTypes.func.isRequired,
        openEditModal: React.PropTypes.func,
        toggleArchiveAssignment: React.PropTypes.func,
        type: React.PropTypes.string
    };

    _handleActionMenuClick(event) {
        event.stopPropagation();
        let target = event.target;

        while(target.getAttribute('class') == null || (target.getAttribute('class').indexOf('card--user') === -1 && target.getAttribute('class').indexOf('card--group') === -1 && target.getAttribute('class').indexOf('card--content') === -1 && target.getAttribute('class').indexOf('card--pinpoint') === -1 && target.getAttribute('class').indexOf('card--assignment') === -1)) {
            target = target.parentNode;
        }

        target.querySelector('.action-menu').classList.add('active');
        target.classList.add('has-active-action-menu');
    }

    _handleClose() {
        document.querySelector('.card.has-active-action-menu').classList.remove('has-active-action-menu');
    }

    render() {
        let { className, createAssignment, handleDelete, item, onClick, openEditModal } = this.props;

        let type = this.props.type || item['classifier'];

        // Changing data made this necessary
        if(type == null) {
            type = item['@classifier'];
        }

        if(type === 'user') {
            return (
                <section className={`card card--user ${className || ''}`}
                         onClick={onClick.bind(this)}>
                    <header className="card__thumbnail">
                        <Thumbnail defaultAvatar="users"
                                   thumbnailID={item.thumbnail ? item.thumbnail.id : null}
                                   alt={`${item.lastName}, ${item.firstName}`} />
                    </header>
                    <div className="card__content">
                        <H4 className="card__title user__name">
                            {item.lastName}, {item.firstName}
                        </H4>
                        <div className={classNames('card__details', 'user__departments', {'no-details': !item.department})}>
                            {item.department ? item.department.name : null}
                        </div>
                        <div className="card-menu">
                            <div role="button" className="card-menu__trigger"
                                 onClick={this._handleActionMenuClick.bind(this)}>
                                <Icon icon="dots" />
                            </div>
                            <ActionMenu onClose={this._handleClose.bind(this)}>
                                <ActionMenuButton onClick={openEditModal.bind(this)}>
                                    Edit User
                                </ActionMenuButton>
                                <ActionMenuButton onClick={handleDelete.bind(this)}>
                                    Remove User
                                </ActionMenuButton>
                                <ActionMenuButton onClick={createAssignment.bind(this)}>
                                    Create Assignment
                                </ActionMenuButton>
                            </ActionMenu>
                        </div>
                    </div>
                </section>
            )
        } else if(type === 'user--review' || type === 'user--selection') {
            return (
                <section className={`card card--user ${className || ''}`}
                         onClick={() => { if(type === 'user--selection') { onClick(); }}}>
                    <header className="card__thumbnail">
                        <Thumbnail defaultAvatar="users"
                                   thumbnailID={item.thumbnail ? item.thumbnail.id : null}
                                   alt={`${item.lastName}, ${item.firstName}`} />
                    </header>
                    <div className="card__content">
                        <div role="button"
                             className="card__action-icon"
                             onClick={() => { if(type === 'user--review') { onClick(); }}}>
                            {type === 'user--selection' ? (
                                    <Icon icon="check"
                                          className="icon--check" />
                                ) : (
                                    <Icon icon="negate"
                                          className="icon--negate" />
                                )}
                            {type === 'user--selection' ? (
                                    <Icon icon="plus"
                                          className="icon--plus"/>
                                ) : null}
                        </div>
                        <H4 className="card__title user__name">
                            {item.lastName}, {item.firstName}
                        </H4>
                        <div className={classNames('card__details', 'user__departments', {'no-details': !item.department})}>
                            {item.department ? item.department.name : null}
                        </div>
                    </div>
                </section>
            )
        } else if(type === 'department') {
            return (
                <section className={`card card--group ${className || ''}`}
                         onClick={onClick.bind(this)}>
                    <header className="card__thumbnail">
                        <Thumbnail defaultAvatar="groups"
                                   thumbnailID={item.thumbnail ? item.thumbnail.id : null}
                                   alt={item.name} />
                    </header>
                    <div className="card__content">
                        <H4 className="card__title group__name">
                            {item.name}
                        </H4>
                        <div className={classNames('card__details', 'group__description', {'no-details': !item.description})}>
                            {item.description ? item.description : null}
                        </div>
                        <div className="card-menu">
                            <div role="button" className="card-menu__trigger"
                                 onClick={this._handleActionMenuClick.bind(this)}>
                                <Icon icon="dots" />
                            </div>
                            <ActionMenu onClose={this._handleClose.bind(this)}>
                                <ActionMenuButton onClick={openEditModal.bind(this)}>
                                    Edit Group
                                </ActionMenuButton>
                                <ActionMenuButton onClick={handleDelete.bind(this)}>
                                    Remove Group
                                </ActionMenuButton>
                                <ActionMenuButton onClick={createAssignment.bind(this)}>
                                    Create Assignment
                                </ActionMenuButton>
                            </ActionMenu>
                        </div>
                    </div>
                </section>
            )
        } else if(type === 'department--review' || type === 'department--selection') {
            return (
                <section className={`card card--group modal__card--group ${className || ''}`}
                         onClick={() => { if(type === 'department--selection') { onClick(); }}}>
                    <header className="card__thumbnail">
                        <Thumbnail defaultAvatar="groups"
                                   thumbnailID={item.thumbnail ? item.thumbnail.id : null}
                                   alt={item.name} />
                    </header>
                    <div className="card__content">
                        <div role="button"
                             className="card__action-icon"
                             onClick={() => { if(type === 'department--review') { onClick(); }}}>
                            {type === 'department--selection' ? (
                                <Icon icon="check"
                                      className="icon--check" />
                            ) : (
                                <Icon icon="negate"
                                      className="icon--negate" />
                            )}
                            {type === 'department--selection' ? (
                                <Icon icon="plus"
                                      className="icon--plus"/>
                            ) : null}
                        </div>
                        <H4 className="card__title group__name">
                            {item.name}
                        </H4>
                        <div className={classNames('card__details', 'group__description', {'no-details': !item.description})}>
                            {item.description ? item.description : null}
                        </div>
                    </div>
                </section>
            )
        } else if(type === 'content') {
            let type = item.type;
            if(type === 'html') {
                type = 'Document';
            }
            return (
                <section className={`card card--content ${className || ''}`}
                         onClick={onClick.bind(this)}>
                    <header className={classNames('card__thumbnail', {'card__thumbnail--has-thumbnail': item.thumbnail != null})}
                            style={{backgroundImage: ''}}>
                        <Thumbnail defaultAvatar={item.marketingType && item.marketingType === 'elearning' ? 'elearning' : item.type}
                                   thumbnailID={item.thumbnail ? item.thumbnail.id : null}
                                   alt={item.type} />
                    </header>
                    <div className="card__content">
                        <H4 className="card__title user__name">
                            {item.name}
                        </H4>
                        <div className="card__details content_type">
                            {generateContentTypeLabel(item)} | {moment(item.modified).format('MM/DD/YY')}
                        </div>
                        <div className="card-menu">
                            <div role="button" className="card-menu__trigger"
                                 onClick={this._handleActionMenuClick.bind(this)}>
                                <Icon icon="dots" />
                            </div>
                            <ActionMenu onClose={this._handleClose.bind(this)}>
                                {item.type === 'file' || item.type === 'checklist' ? (
                                    <ActionMenuButton onClick={openEditModal.bind(this)}>
                                        Edit Content
                                    </ActionMenuButton>
                                ) : null}
                                <ActionMenuButton onClick={handleDelete.bind(this)}>
                                    Remove Content
                                </ActionMenuButton>
                                <ActionMenuButton onClick={createAssignment.bind(this)}>
                                    Create Assignment
                                </ActionMenuButton>
                            </ActionMenu>
                        </div>
                    </div>
                </section>
            )
        } else if(type === 'content--review' || type === 'content--selection') {
            return (
                <section className={`card card--content modal__card modal__card--content ${className || ''}`}
                         onClick={() => { if(type === 'content--selection') { onClick(); }}}
                         data-id={item.id}>
                    <header className={classNames('card__thumbnail', {'card__thumbnail--has-thumbnail': item.thumbnail != null})}
                            style={{backgroundImage: ''}}>
                        <Thumbnail defaultAvatar={item.marketingType && item.marketingType === 'elearning' ? 'elearning' : item.type}
                                   thumbnailID={item.thumbnail ? item.thumbnail.id : null}
                                   alt={item.type} />
                    </header>
                    <div className="card__content">
                        <div role="button"
                             className="card__action-icon"
                             onClick={() => { if(type === 'content--review') { onClick(); }}}>
                            {type === 'content--selection' ? (
                                <Icon icon="check"
                                      className="icon--check" />
                            ) : (
                                <Icon icon="negate"
                                      className="icon--negate" />
                            )}
                            {type === 'content--selection' ? (
                                <Icon icon="plus"
                                      className="icon--plus"/>
                            ) : null}
                        </div>
                        <H4 className="card__title user__name">
                            {item.name}
                        </H4>
                        <div className="card__details content_type">
                            {generateContentTypeLabel(item)} | {moment(item.modified).format('MM/DD/YY')}
                        </div>
                    </div>
                    <div className="card__drag-handle">
                        <Icon icon="drag" />
                    </div>
                </section>
            )
        } else if(type === 'beacon') {
            let subtitle = '';
            if(item.type === 'uuid') {
                subtitle = 'Beacon | ' + item.beaconId;
            } else {
                subtitle = 'GPS | ';
                if(item.address != null) {
                    subtitle += item.address;
                } else {
                    subtitle += `${item.latitude.toFixed(2)}, ${item.longitude.toFixed(2)}`;
                }
            }
            return (
                <section className={`card card--pinpoint ${className || ''}`}
                         onClick={onClick.bind(this)}>
                    <header className={classNames('card__thumbnail', {'card__thumbnail--has-thumbnail': item.thumbnail != null})}
                            style={{backgroundImage: ''}}>
                        <Thumbnail defaultAvatar={item.type === 'uuid' ? 'bluetooth' : 'gps'}
                                   thumbnailID={item.thumbnail ? item.thumbnail.id : null}
                                   alt={item.type} />
                        <div className="card__thumbnail-text">
                            {item.type === 'uuid' ? 'Beacon' : 'GPS'}
                        </div>
                    </header>
                    <div className="card__content">
                        <H4 className="card__title user__name">
                            {item.name}
                        </H4>
                        <div className="card__details beacon__type">
                            {subtitle}
                        </div>
                        <div className="card-menu">
                            <div role="button" className="card-menu__trigger"
                                 onClick={this._handleActionMenuClick.bind(this)}>
                                <Icon icon="dots" />
                            </div>
                            <ActionMenu onClose={this._handleClose.bind(this)}>
                                <ActionMenuButton onClick={handleDelete.bind(this)}>
                                    Remove PinPoint
                                </ActionMenuButton>
                                <ActionMenuButton onClick={createAssignment.bind(this)}>
                                    Create Assignment
                                </ActionMenuButton>
                            </ActionMenu>
                        </div>
                    </div>
                </section>
            )
        } else if(type === 'beacon--review' || type === 'beacon--selection') {
            return (
                <section className={`card card--pinpoint ${className || ''}`}
                         onClick={() => { if(type === 'beacon--selection') { onClick(); }}}>
                    <header className={classNames('card__thumbnail', {'card__thumbnail--has-thumbnail': item.thumbnail != null})}
                            style={{backgroundImage: ''}}>
                        <Thumbnail defaultAvatar={item.type === 'uuid' ? 'bluetooth' : 'gps'}
                                   thumbnailID={item.thumbnail ? item.thumbnail.id : null}
                                   alt={item.type} />
                        <div className="card__thumbnail-text">
                            {item.type === 'uuid' ? 'Beacon' : 'GPS'}
                        </div>
                    </header>
                    <div className="card__content">
                        <div role="button"
                             className="card__action-icon"
                             onClick={() => { if(type === 'beacon--review') { onClick(); }}}>
                            {type === 'beacon--selection' ? (
                                    <Icon icon="check"
                                          className="icon--check" />
                                ) : null}
                            {type === 'beacon--selection' ? (
                                    <Icon icon="plus"
                                          className="icon--plus"/>
                                ) : null}
                            {type === 'beacon--review' ? (
                                <Icon icon="negate"
                                      className="icon--remove" />
                            ) : null}
                        </div>
                        <H4 className="card__title user__name">
                            {item.name}
                        </H4>
                        <div className="card__details beacon__type">
                            {item.type === 'uuid' ? 'Beacon' : 'GPS'} | {item.type === 'uuid' ? item.beaconId : `${item.latitude.toFixed(2)}, ${item.longitude.toFixed(2)}` }
                        </div>
                    </div>
                </section>
            )
        } else if(type === 'assignment') {
            let details = {};
            let defaultAvatar = null;
            if(item.contents.length > 0) {
                details = item.contents[0];
                if(details.marketingType && details.marketingType === 'elearning') {
                    defaultAvatar = 'elearning';
                } else if(details.type) {
                    defaultAvatar = details.type;
                } else {
                    defaultAvatar = 'draft';
                }
            } else {
                defaultAvatar = 'draft';
            }

            return (
                <section className={`card card--assignment ${className || ''}`}
                         onClick={onClick.bind(this)}>
                    <header className={classNames('card__thumbnail', {'card__thumbnail--has-thumbnail': details.thumbnail != null})}
                            style={{backgroundImage: ''}}>
                        <Thumbnail defaultAvatar={defaultAvatar}
                                   thumbnailID={details.thumbnail ? details.thumbnail.id : null}
                                   alt={item.type} />
                        {item.state !== ASSIGNMENT_STATES.UNPUBLISHED && item.state !== ASSIGNMENT_STATES.CANCELLED && item.status !== ASSIGNMENT_STATUSES.NO_PROGRESS ? (
                            <span className={`progress-label progress-label--${item.status}`}>
                                {displayAssignmentStatus(item.state, item.status)}
                            </span>
                        ) : null}
                    </header>
                    <div className="card__content">
                        <H4 className="card__title user__name">
                            {item.name}
                        </H4>
                        <div className="card__details assignment__dates">
                            Start: {item.startDate ? moment(item.startDate).format('M/D/YY') : '--'} | Due: {item.dueDate ? moment(item.dueDate).format('M/D/YY') : '--'}
                        </div>
                        <div className="card__details assignment__status-label">
                            {item.state === ASSIGNMENT_STATES.UNPUBLISHED ? <span className="status-label status-label--draft">{ASSIGNMENT_STATES_LOOKUP[item.state]}</span> : null}
                            {item.state === ASSIGNMENT_STATES.CANCELLED ? <span className="status-label status-label--cancelled">{ASSIGNMENT_STATES_LOOKUP[item.state]}</span> : null}
                        </div>
                        <div className="card-menu">
                            <div role="button" className="card-menu__trigger"
                                 onClick={this._handleActionMenuClick.bind(this)}>
                                <Icon icon="dots" />
                            </div>
                            <ActionMenu onClose={this._handleClose.bind(this)}>
                                <ActionMenuButton disabled={[ASSIGNMENT_STATES.IN_PROGRESS, ASSIGNMENT_STATES.COMPLETED, ASSIGNMENT_STATES.CANCELLED].indexOf(item.state) !== -1}
                                                  onClick={openEditModal.bind(this)}>
                                    Edit Assignment
                                </ActionMenuButton>
                                <ActionMenuButton onClick={this.props.cloneAssignment.bind(this)}>
                                    Clone Assignment
                                </ActionMenuButton>
                                {item.archived === true ? (
                                    <ActionMenuButton onClick={this.props.toggleArchiveAssignment.bind(this)}>
                                        Unarchive Assignment
                                    </ActionMenuButton>
                                ) : (
                                    <ActionMenuButton onClick={this.props.toggleArchiveAssignment.bind(this)}>
                                        Archive Assignment
                                    </ActionMenuButton>
                                )}
                                <ActionMenuButton onClick={handleDelete.bind(this)}>
                                    {stopAssignmentOrRemoveAssignment(item.state, item.status) === true ? 'Stop Assignment' : 'Remove Assignment'}
                                </ActionMenuButton>
                            </ActionMenu>
                        </div>
                    </div>
                </section>
            )
        } else if(type === 'checklist-item') {
            return (
                <section className={`card card--checklist-item modal__card modal__card--checklist-item ${className || ''}`} data-index={this.props.dataIndex} onClick={onClick.bind(this)}>
                    <header className={classNames('card__thumbnail', {'card__thumbnail--has-thumbnail': item.thumbnail != null})}
                            style={{backgroundImage: ''}}>
                        <Thumbnail defaultAvatar="image"
                                   thumbnailID={item.thumbnail && item.thumbnail.id ? item.thumbnail.id : null}
                                   thumbnailToUpload={item.thumbnail && item.thumbnail.id == null ? item.thumbnail : null}
                                   alt={item.name} />
                    </header>
                    <div className="card__content">
                        <div role="button"
                             className="card__action-icon"
                             onClick={(event) => {
                                 event.stopPropagation();
                                 this.props.removeItem();
                             }}>
                            <Icon icon="negate"
                                      className="icon--negate" />
                        </div>
                        <H4 className="card__title user__name">
                            {item.name}
                        </H4>
                    </div>
                    <div className="card__drag-handle">
                        <Icon icon="drag" />
                    </div>
                </section>
            )
        } else {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Card/index.js